"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.h5Login = void 0;
var cookie_1 = __importDefault(require("@tencent/vft-common/cookie"));
var date = __importStar(require("@tencent/vft-common/date"));
var env_1 = __importDefault(require("@tencent/vft-common/env"));
var logger_1 = __importDefault(require("@tencent/vft-common/logger"));
var request_1 = require("@tencent/vft-common/request");
var countries_1 = require("../config/countries");
var wetvEnv_1 = require("../wetvEnv");
var host = /iflix\.com$/.test(location.host) ? 'hwvip.iflix.com' : 'hwvip.wetv.vip';
var oneYearExpires = (new Date(Date.now() + 60 * 60 * 24 * 365 * 1000)).toUTCString();
var emptyFunc = function () {
    // do nothing.
};
var h5WevtLogin = {
    onLogin: emptyFunc,
    onLogout: emptyFunc,
    show: emptyFunc,
    hide: emptyFunc,
    refreshLogin: emptyFunc,
    handleLoginOut: emptyFunc,
};
if (window.wetvLogin) {
    h5WevtLogin = window.wetvLogin;
}
// 文档 https://git.woa.com/WeTV/WPC/common/sdk/wpc-wetv-login-sdk/blob/master/readme.md
exports.h5Login = h5WevtLogin;
// 拆解区号和手机号
function extractAreaAndPhone(target) {
    if (target === void 0) { target = ''; }
    var result = target.match(/(.*)-([0-9]+)/);
    return {
        areacode: (result === null || result === void 0 ? void 0 : result[1]) || '',
        phoneNumber: (result === null || result === void 0 ? void 0 : result[2]) || '',
    };
}
// 设置h5login所需的cookie
function setH5LoginCookie() {
    var langCodeMap = {
        cn: 'zh-cn',
        tw: 'zh-tw',
    };
    var langCodeInCookie = cookie_1.default.get('wetv_lang');
    var areaCodeInCookie = cookie_1.default.get('wetv_areaid');
    var currentAreaCode = countries_1.findCountryAreacodeByCode(wetvEnv_1.COUNTRY.code);
    var currentLangCode = langCodeMap[wetvEnv_1.LANG.name] || wetvEnv_1.LANG.name;
    // H5登录组件语言
    if (!langCodeInCookie || (langCodeInCookie !== currentLangCode)) {
        cookie_1.default.set('wetv_lang', currentLangCode, { domain: '.wetv.vip', expires: oneYearExpires, path: '/' });
    }
    // H5登录组件区号
    if (!areaCodeInCookie || (areaCodeInCookie !== encodeURIComponent(currentAreaCode))) {
        cookie_1.default.set('wetv_areaid', currentAreaCode, { domain: '.wetv.vip', expires: oneYearExpires, path: '/' });
    }
}
if (!env_1.default.isApp) {
    setH5LoginCookie();
}
var PollingIntervals;
(function (PollingIntervals) {
    /** 默认轮询间隔 */
    PollingIntervals[PollingIntervals["DEFAULTS"] = 30] = "DEFAULTS";
    /** 为避免script加载缓存不触发onload事件的情况，而使用的轮询策略 */
    PollingIntervals[PollingIntervals["CACHED_SCRIPT_FALLBACK"] = 100] = "CACHED_SCRIPT_FALLBACK";
})(PollingIntervals || (PollingIntervals = {}));
var maxPollingTimes = 20;
var pollingTimes = 0;
var H5Login = /** @class */ (function () {
    function H5Login() {
        var _this = this;
        this.readyListeners = [];
        this.pollingIntervals = PollingIntervals.DEFAULTS;
        this.onReady(function () {
            _this.onLogin(function () {
                _this.close();
            });
        });
        // 兼容wetvlib.js script标签同步引用，无需调用login.init也处于ready状态
        if (window.wetvLogin) {
            this.ready();
        }
    }
    /**
     * 是否已登录
     * @returns {boolean} 是否已登录
     */
    H5Login.prototype.isLogin = function () {
        var _a;
        return Boolean((_a = this.wetvLogin) === null || _a === void 0 ? void 0 : _a.isLogin);
    };
    /**
     * 返回用户信息
     * @returns {Promise<UserInfo|null>} 用户信息
     */
    H5Login.prototype.getUserInfo = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c, avatar, _d, nick, mainLogin, phone, uid, others, _e, areacode, phoneNumber;
            return __generator(this, function (_f) {
                if (!this.isLogin()) {
                    return [2 /*return*/, null];
                }
                try {
                    _b = ((_a = this.wetvLogin) === null || _a === void 0 ? void 0 : _a.userInfo) || {}, _c = _b.avatar, avatar = _c === void 0 ? '' : _c, _d = _b.nick, nick = _d === void 0 ? '' : _d, mainLogin = _b.mainLogin, phone = _b.phone, uid = _b.uid, others = __rest(_b, ["avatar", "nick", "mainLogin", "phone", "uid"]);
                    _e = extractAreaAndPhone(phone), areacode = _e.areacode, phoneNumber = _e.phoneNumber;
                    return [2 /*return*/, __assign({ type: mainLogin, headImgUrl: avatar, vuid: uid, nickname: nick, areacode: areacode, phone: phoneNumber }, others)];
                }
                catch (e) {
                    logger_1.default.error('[wetv-common/login/H5Login.getUserInfo]获取userinfo异常', e);
                }
                return [2 /*return*/, null];
            });
        });
    };
    /**
     * 获取PayVip信息
     * https://iwiki.woa.com/pages/viewpage.action?pageId=1841081395
     * @returns {Promise<PayVip|null>}
     */
    H5Login.prototype.getPayVip = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, vipUserInfo, isVip, beginTime, endTime, others, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = "//" + host + "/fcgi-bin/hw_comm_cgi?name=query_vipinfo_international&plat=2&otype=xjson&guid=" + cookie_1.default.get('guid');
                        return [4 /*yield*/, request_1.request(url, null, {
                                withCredentials: true,
                            })];
                    case 1:
                        vipUserInfo = (_a.sent()).vipUserInfo;
                        if (!vipUserInfo) {
                            return [2 /*return*/, null];
                        }
                        isVip = vipUserInfo.isVip, beginTime = vipUserInfo.beginTime, endTime = vipUserInfo.endTime, others = __rest(vipUserInfo, ["isVip", "beginTime", "endTime"]);
                        return [2 /*return*/, __assign({ vip: isVip, beginTime: beginTime ? date.format(beginTime * 1000, 'Y-mm-dd H:i:s') : '', endTime: endTime ? date.format(endTime * 1000, 'Y-mm-dd H:i:s') : '' }, others)];
                    case 2:
                        e_1 = _a.sent();
                        logger_1.default.error('[wetv-common/login/H5Login.getPayVip]获取payvip信息异常', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    // 打开登录
    H5Login.prototype.openLogin = function () {
        try {
            this.invokeWeTVLogin('show');
        }
        catch (e) {
            logger_1.default.error('[wetv-common/login/H5Login.openLogin]', e);
            return Promise.reject(e);
        }
        return Promise.resolve();
    };
    // 退出登录
    H5Login.prototype.logout = function () {
        try {
            this.invokeWeTVLogin('handleLoginOut');
        }
        catch (e) {
            logger_1.default.error('[wetv-common/login/H5Login.logout]', e);
            return Promise.reject(e);
        }
        return Promise.resolve();
    };
    // 监听登录成功事件
    H5Login.prototype.onLogin = function (callback) {
        return this.invokeWeTVLogin('onLogin', callback);
    };
    // 监听退出登录事件
    H5Login.prototype.onLogout = function (callback) {
        return this.invokeWeTVLogin('onLogout', callback);
    };
    /**
     * 注册login初始化完成回调
     * @param {AnyFn} callback login初始化完成后执行的回调函数
     */
    H5Login.prototype.onReady = function (callback) {
        if (this.hasWeTVLoginReady()) {
            return callback();
        }
        this.readyListeners.push(callback);
    };
    /**
     * 初始化完成
     */
    H5Login.prototype.ready = function () {
        var _this = this;
        if (this.hasWeTVLoginReady()) {
            return;
        }
        if (!window.wetvLogin) {
            throw new Error('[wetv-common/H5Login.ready]wetvLogin SDK不存在');
        }
        this.wetvLogin = window.wetvLogin;
        this.onLogin(function () {
            _this.close();
        });
        this.readyListeners.forEach(function (callback) { return callback(); });
        this.readyListeners = [];
    };
    /**
     * 初始化login库
     * @param {String} [id] wetv login的script标签的id，如果不传则会用轮询方式检测window.wetvLogin是否存在
     */
    H5Login.prototype.init = function (id) {
        var _this = this;
        this.pollingIntervals = id ? PollingIntervals.CACHED_SCRIPT_FALLBACK : PollingIntervals.DEFAULTS;
        this.pollingReady();
        if (!id) {
            return;
        }
        var el = document.getElementById(id);
        if (!el) {
            return;
        }
        var timer = setTimeout(function () {
            _this.ready();
        }, 3000); // 设置超时时间
        el.onload = function () {
            clearTimeout(timer);
            _this.ready();
            el.onload = null;
        };
        this.onReady(function () {
            clearTimeout(timer);
            el.onload = null;
        });
    };
    H5Login.prototype.close = function () {
        this.invokeWeTVLogin('hide');
    };
    /**
     * 轮询检测wetvLogin是否已存在
     */
    H5Login.prototype.pollingReady = function () {
        var _this = this;
        if (window.wetvLogin || pollingTimes >= maxPollingTimes) {
            this.ready();
            return;
        }
        pollingTimes += 1;
        setTimeout(function () {
            _this.pollingReady();
        }, this.pollingIntervals);
    };
    /**
     * 判断window.wetvLogin是否已存在
     * @returns {boolean}
     */
    H5Login.prototype.hasWeTVLoginReady = function () {
        return !!this.wetvLogin;
    };
    H5Login.prototype.invokeWeTVLogin = function (prop) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.hasWeTVLoginReady()) {
            throw new Error("[wetv-common/H5Login.invokeWeTVLogin]\u65E0\u6CD5\u5728wetvLogin SDK\u52A0\u8F7D\u5B8C\u6210\u524D\u8BBF\u95EE\u5C5E\u6027(prop: " + prop + ", args: " + args + ")");
        }
        var caller = (_a = this.wetvLogin) === null || _a === void 0 ? void 0 : _a[prop];
        if (typeof caller === 'function') {
            return caller.apply(this.wetvLogin, args);
        }
        return caller;
    };
    return H5Login;
}());
exports.default = H5Login;
